import styled from '@mui/system/styled'
import { rgba } from 'polished'

import { statusChipBase } from 'components/Status/Status.styles'

import { theme } from 'styles/theme'

export const AlertWrapper = styled('div')(() => ({
  position: 'absolute',
  right: 10,
  top: 90,
  zIndex: 999999
}))

export const GroupListWrapper = styled('div')(() => ({
  display: 'flex',
  columnGap: 12,
  rowGap: 12,
  maxHeight: 190,
  padding: 5,
  paddingBottom: 5,
  overflowX: 'auto'
}))

const getStatus = (status: string) => {
  switch (status) {
    case 'archived_customer':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'inactive_customer':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    case 'lead':
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.1)
      }
    case 'active_customer':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'churned':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'lost':
      return {
        color: theme.palette.neutral[300],
        background: rgba(theme.palette.neutral[300], 0.1)
      }
    default:
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
  }
}

type StatusProps = {
  status: string
}

export const Status = styled('div')<StatusProps>(({ status }) => ({
  ...statusChipBase,
  ...getStatus(status)
}))
